export type StrictModeState = {
  enabled: boolean;
  enabledAt?: number;
};

// Spacelift DevTools
export const isStrictModeEnabled = (): boolean => {
  try {
    const stored = localStorage.getItem("strict-mode-enabled");
    if (stored) {
      const state: StrictModeState = JSON.parse(stored);
      return state.enabled || false;
    }
  } catch (error) {
    console.warn("StrictMode: Failed to read localStorage state:", error);
  }

  return false;
};
